<div class="flex flex-col gap-4 p-3">
  <div class="flex min-h-[2.5rem] w-full items-center justify-center px-10">
    <h4 class="text-center text-base">{{ questionNumberTitle() }} {{ question.title }}</h4>
  </div>
  <div class="flex flex-col gap-2">
    <div
      *ngFor="let answer of lifemapAnswers()"
      class="flex cursor-pointer items-center justify-center rounded bg-pl-gray-250 p-2 hover:bg-pl-gray-300"
      [ngClass]="{
        'bg-pl-orange-200 text-pl-orange-800 hover:bg-pl-orange-300': answer.answerValue === answerValue()
      }"
      (click)="onQuestionAnswered(answer.answerValue)"
    >
      <p
        class="text-center font-bold text-pl-gray-450"
        [ngClass]="{
          'text-pl-orange-800': answer.answerValue === answerValue()
        }"
      >
        {{ answer.title }}
      </p>
    </div>
  </div>
</div>
